import React, { useEffect, useRef } from 'react';
// Removed unused 'useState' import
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

// Updated to use global styles for consistent text styling
const StyledPublicationSection = styled.section`
  font-family: var(--font-sans);
  font-size: var(--fz-md);
  line-height: var(--line-height-base);
  color: var(--slate);

  h2 {
    font-size: var(--fz-heading);
  }

  p {
    margin-bottom: var(--spacing-md);
  }

  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 50px 40px; /* Reduced top padding from 80px to 60px */
  text-align: left; // Updated text alignment to left for consistency

  @media (max-width: 768px) {
    padding: 60px 30px;
  }
  @media (max-width: 480px) {
    padding: 40px 20px;
  }

  .publication {
    margin-bottom: 50px;
    text-align: left;

    h3 {
      font-size: var(--fz-xl); /* Reduced font size from --fz-xxl */
      margin-bottom: 10px;

      .conference {
        display: block;
        font-size: var(--fz-sm);
        color: var(--light-slate);
      }
    }

    .description {
      margin: 20px 0;
      font-size: var(--fz-md);
      color: var(--slate);
    }

    .show-publication {
      display: inline-block;
      margin-top: 10px;
      padding: 10px 20px;
      font-size: var(--fz-sm);
      color: var(--green);
      border: 1px solid var(--green);
      border-radius: var(--border-radius);
      text-decoration: none;

      &:hover {
        background-color: var(--green-tint);
      }
    }
  }
`;

const Publication = () => {
  const data = useStaticQuery(graphql`
    query {
      publications: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/content/publications/" } }
        sort: { fields: [frontmatter___date], order: DESC }
      ) {
        edges {
          node {
            frontmatter {
              title
              author
              date(formatString: "MMMM D, YYYY")
              publication
              location
              url
            }
            html
          }
        }
      }
    }
  `);

  const publicationsData = data.publications.edges;
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledPublicationSection id="publications" ref={revealContainer}>
      <h2 className="numbered-heading">Publications</h2>

      {publicationsData &&
        publicationsData.map(({ node }, i) => {
          const { frontmatter, html } = node;
          const { title, author, date, publication, location, url } = frontmatter;

          return (
            <div key={i} className="publication">
              <h3>
                {title}
                <span className="conference">
                  {publication}, {location}, by {author} · {date}
                </span>
              </h3>
              <div className="description" dangerouslySetInnerHTML={{ __html: html }} />
              {url && (
                <a
                  className="show-publication"
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer">
                  Show publication
                </a>
              )}
            </div>
          );
        })}
    </StyledPublicationSection>
  );
};

export default Publication;
